import React, { useState } from "react";
import { EventBus } from "./eventBus";
import { generateId, formatDate } from "host/utils";

const CANCEL_REASONS = [
  { id: "1", label: "行程有变，不需要用车" },
  { id: "2", label: "找到了更便宜的车辆" },
  { id: "3", label: "车辆不符合需求" },
  { id: "4", label: "重复下单" },
  { id: "5", label: "其他原因" },
];

const CancelOrder: React.FC = () => {
  const [selectedReason, setSelectedReason] = useState<string>("");
  const [otherReason, setOtherReason] = useState<string>("");

  const handleReasonChange = (reasonId: string) => {
    setSelectedReason(reasonId);
    if (reasonId !== "5") {
      setOtherReason("");
    }
  };

  const handleConfirm = () => {
    if (!selectedReason) {
      alert("请选择取消原因");
      return;
    }

    const reason = selectedReason === "5" ? otherReason : CANCEL_REASONS.find((r) => r.id === selectedReason)?.label;
    
    if (selectedReason === "5" && !otherReason.trim()) {
      alert("请输入其他原因");
      return;
    }

    EventBus.emit("order-cancel-message", {
      type: "cancel-order",
      reasonId: selectedReason,
      reason: reason,
      orderId: generateId(),
      cancelTime: formatDate(new Date()),
    });
  };

  return (
    <div style={{ padding: "20px", maxWidth: "500px", margin: "0 auto" }}>
      <h1 className="text-primary glow-text" style={{ marginBottom: "20px", fontSize: "20px", fontWeight: "bold" }}>取消订单</h1>
      <div style={{ marginBottom: "20px" }}>
        <div className="text-secondary" style={{ marginBottom: "12px", fontSize: "14px" }}>请选择取消原因：</div>
        {CANCEL_REASONS.map((reason) => (
          <label
            key={reason.id}
            className="glass-card"
            style={{
              display: "block",
              padding: "12px",
              marginBottom: "8px",
              cursor: "pointer",
              borderColor: selectedReason === reason.id ? "var(--color-border-glow)" : "var(--glass-border)",
            }}
          >
            <input
              type="radio"
              name="cancelReason"
              value={reason.id}
              checked={selectedReason === reason.id}
              onChange={(e) => handleReasonChange(e.target.value)}
              style={{ marginRight: "8px", accentColor: "var(--color-primary)" }}
            />
            <span className={selectedReason === reason.id ? "text-accent" : "text-secondary"}>{reason.label}</span>
          </label>
        ))}
        {selectedReason === "5" && (
          <textarea
            value={otherReason}
            onChange={(e) => setOtherReason(e.target.value)}
            placeholder="请输入其他原因"
            className="glass-card"
            style={{
              width: "100%",
              minHeight: "80px",
              padding: "8px",
              marginTop: "8px",
              fontSize: "14px",
              boxSizing: "border-box",
              color: "var(--color-text-primary)",
              background: "var(--glass-background)",
              borderColor: "var(--glass-border)",
            }}
          />
        )}
      </div>
      <button
        onClick={handleConfirm}
        className="btn-primary"
        style={{
          width: "100%",
        }}
      >
        确认取消
      </button>
    </div>
  );
};

export default CancelOrder;

